import React, {FC} from 'react';
import MenuItem from '@mui/material/MenuItem';
import {Box, Chip} from '@mui/material';
import TextField from '@mui/material/TextField';
import {SelectProps} from './Select';

export interface MultiSelectInputProps extends Omit<SelectProps, 'value'> {
  value: string[],
  onDeleteSelectedValue: (value: string) => void
}

const getLabel = (options, value) => {
  const selectedOption = options?.find((option) => option.value === value);

  return selectedOption?.label || '';
};

const MultiSelect: FC<MultiSelectInputProps> = ({
  name,
  id,
  value = [],
  label,
  options,
  onChange,
  onDeleteSelectedValue,
  error,
  touched,
  onFocus,
  onBlur,
  apiValidationError,
  size = 'medium',
  disabled = false,
  autoWidth = false
}) => {
  const hasErrors = !!apiValidationError || !!(touched && error);
  const errorMessage = apiValidationError?.[name] || (touched && error);

  const selectProps = {
    autoWidth,
    multiple: true,
    renderValue: (selected) => (
      <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
        {Array.isArray(selected) && selected.map((selectedValue) => (
          <Chip
            size={size}
            key={selectedValue}
            label={getLabel(options, selectedValue)}
            onDelete={() => onDeleteSelectedValue(selectedValue)}
            onMouseDown={(event) => {
              event.stopPropagation();
            }}
          />
        ))}
      </Box>
    )
  };

  return (
    <TextField
      name={name}
      id={id}
      select
      SelectProps={selectProps}
      label={label}
      onFocus={onFocus}
      onBlur={onBlur}
      value={value || []}
      onChange={onChange}
      error={hasErrors}
      helperText={errorMessage}
      size={size}
      disabled={disabled}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default MultiSelect;
